/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

CampusKMU Group-Containers

*/

$(function() {
  // set first content active
  $('.campuskmu-container__content').first().addClass('active');

  $('.campuskmu-container__list__toggle, .campuskmu-container__item__toggle').on('click', function(event) {
    event.preventDefault();
    const content = $(`${$(this).attr('href')}`);
    $('.campuskmu-container .active').removeClass('active');
    content.addClass('active');
  });
});



// WEBPACK FOOTER //
// ./static/js/modules/campuskmu.js